export default "__VITE_ASSET__BZhQN6_A__"